import { Button, Menu, MenuItem } from "@mui/material";
import { useState, memo } from "react";
import styles from "./styles.module.css";

const GenericMenu = memo(({ icon, buttons }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState(0);
  const [label, setLabel] = useState(buttons[0].label);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (index, onClick, label) => {
    setSelected(index);
    setLabel(label);
    handleClose();
    onClick();
  };

  return (
    <>
      <div>
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className={styles.button__menu}
        >
          {icon}
          {label}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {buttons && buttons.length > 0
            ? buttons.map((button, index) => (
                <MenuItem
                  name={button.name}
                  key={index}
                  className={
                    selected === index ? styles.menuIten__selected : null
                  }
                  onClick={() =>
                    handleMenuItemClick(index, button.onClick, button.label)
                  }
                >
                  <p>{button.label}</p>
                </MenuItem>
              ))
            : ""}
        </Menu>
      </div>
    </>
  );
});

export default GenericMenu;
